/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

angular.module('bulbApp.jplayerModule', ['bulbApp.errorModule'])

.constant('JPLAYER', {
  defaultOptions: {
    swfPath : 'https://assets.bulbapp.com/jPlayer-2.9.2/dist/jplayer/jquery.jplayer.swf',
    supplied: 'mp3, mp4, wav',
    backgroundColor: '#737c89', // $bulb-medium-gray
    volume: 0.5,
    muted: false,
    smoothPlayBar: true,
    toggleDuration: true,
    remainingDuration: true,
    useStateClassSkin: true,
    autoBlur: false,
    errorAlerts: false,
    warningAlerts: false
  },

  bitrate: [
    // The different quality encodings we support
    32,
    96,
    128,
    192
  ]

});


